import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../DestinationOffer/DestinationOffer.css";

const offers = [
  { id: "turkey", image: "/turkey.jpg", location: "Cappadocia & Turkish Riviera", nights: 7, price: 699 },
  { id: "morocco", image: "/morocco.jpg", location: "Magical Morocco: Sahara & Coast", nights: 9, price: 899 },
  { id: "dubai", image: "/dubai.jpg", location: "Dubai & Abu Dhabi Luxury Experience", nights: 8, price: 1299 },
  { id: "maldives", image: "/maldives.jpg", location: "Indian Ocean Paradise: Maldives", nights: 10, price: 1999 },
  { id: "thailand", image: "/thailand.jpg", location: "Thailand: Islands & Culture", nights: 12, price: 1199 },
  { id: "indonesia", image: "/indonesia.jpg", location: "Indonesia: Bali & Beyond", nights: 10, price: 1299 },
  { id: "malaysia", image: "/malasiya.jpg", location: "Malaysia: Modern & Traditional", nights: 9, price: 1099 },
  { id: "india", image: "/india.jpg", location: "India: Colors & Contrasts", nights: 14, price: 1499 },
  { id: "srilanka", image: "/srilanka.jpg", location: "Sri Lanka: Island Treasures", nights: 8, price: 999 },
  { id: "southafrica", image: "/southafrica.jpg", location: "South Africa: Wildlife & Wonders", nights: 12, price: 1799 },
  { id: "japan", image: "/japan.jpg", location: "Japan: Cherry Blossoms & Culture", nights: 10, price: 1999 },
  { id: "greece", image: "/greece.jpg", location: "Greece: Islands & Ancient Wonders", nights: 9, price: 1599 },
  { id: "kenya-safari", image: "/kenya-safari.webp", location: "Kenya Safari: Masai Mara & African Majesty", nights: 5, price: 2099 }
];

const DestinationOffer = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="destination-offer-df">
      <h1 className="heading-df">Our Top Holidays Offers!</h1>
      <p className="subtext-df">
        Your one-stop shop for last-minute holidays. Book your amazing trip with us.
      </p>
      <div className="offers-grid-df">
        {(showMore ? offers : offers.slice(0, 8)).map((offer, index) => (
          <Link  key={offer.id} to={`/holidays/${offer.id}`} className="offer-card-df-link">
            <div className={`offer-card-df ${index % 2 !== 0 ? "translate-down-df" : ""}`}>
              <div className="luz"></div>
              <img className="offer-image-df" src={offer.image} alt={offer.location} />
              <h3 className="offer-title-df">
                {offer.location} - {offer.nights} Nights
              </h3>
              <hr className="divider-df" />
              <p className="offer-price-df">
                {offer.nights} nights from <strong>£{offer.price}pp</strong>
              </p>
            </div>
          </Link>
        ))}
      </div>
      <button className="view-more-btn-df" onClick={() => setShowMore(!showMore)}>
        {showMore ? "Show Less" : "View More"}
      </button>
    </div>
  );
};

export default DestinationOffer;
